import { useEffect } from 'react';
import {
  CopilotProvider,
  CopilotPopoutView,
  announcePopout,
} from '@/features/copilot';

export default function CopilotPopout() {
  // Tell the main window the popout is live so its inline widget hides, and
  // announce close on unload so the widget reappears.
  useEffect(() => {
    announcePopout('open');
    const onUnload = () => announcePopout('close');
    window.addEventListener('beforeunload', onUnload);
    return () => {
      window.removeEventListener('beforeunload', onUnload);
      announcePopout('close');
    };
  }, []);

  return (
    <CopilotProvider>
      <CopilotPopoutView />
    </CopilotProvider>
  );
}
